// Cooperative slicing of long main-thread work (map build, shader warm-up): the network
// callbacks and the ping timer must keep running while a match loads, or the server times the
// connection out before Ready.

/**
 * Lets the browser run other tasks (socket messages, timers, input) before the work goes on.
 * A message-channel task, not `scheduler.yield()`: that one resumes ahead of every other task of
 * its priority, timers and socket callbacks included.
 */
export function yieldToEventLoop(): Promise<void> {
  return new Promise((resolve) => {
    const channel = new MessageChannel();
    channel.port1.onmessage = () => {
      channel.port1.close();
      resolve();
    };
    channel.port2.postMessage(0);
  });
}

/** Yields once the current slice of work has used up its time budget. */
export class Slicer {
  private start = performance.now();

  constructor(private readonly budgetMs: number) {}

  async turn(): Promise<void> {
    if (performance.now() - this.start < this.budgetMs) return;
    await yieldToEventLoop();
    this.start = performance.now();
  }
}
